<template>
  <div class="r-root-page">
    <div>
      <router-view/>
    </div>
    <div class="r-footer">
      <support />
    </div>
  </div>
</template>

<script>

import Support from '@/components/Support';

export default {
  name: 'Lightup',
  components: { Support },
};
</script>
